import { render, staticRenderFns } from "./SoftbookProductPage.vue?vue&type=template&id=54a053f8&"
import script from "./SoftbookProductPage.ts?vue&type=script&lang=ts&"
export * from "./SoftbookProductPage.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SoftbookProductPage.vue"
export default component.exports